import VueI18n from 'vue-i18n'
import { RouteConfig } from 'vue-router'

const ConstructionParamsView: DynamicImport = () => import(/* webpackChunkName: "construction" */ '../views/ConstructionParamsView.vue')

const configRoutes: (i18n: VueI18n) => RouteConfig[] = i18n => ([
  {
    path: 'constructions',
    name: 'constructions-params',
    component: ConstructionParamsView,
    meta: {
      title: i18n.t('constructions.params.pageTitle'),
      appModule: 'construction'
    }
  }
])

export default configRoutes
